import HttpRequest from "../../api/HttpRequest";
import Api from "../../constants/Api";

class GlobalDialerService {
    searchContactFromElastic(params) {
        return HttpRequest.get(Api.searchContactFromElastic, params);
    }

    getVirtualNumbers() {
        return HttpRequest.get(Api.getVirtualNumberFromTenant);
    }

    getTeamMembers() {
        return HttpRequest.post(Api.teamUserList);
    }
}

const GlobalDialerServiceInstance = new GlobalDialerService();
export default GlobalDialerServiceInstance;